var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "Dankesehr! Wir haben deinen Kommentar gespeichert.\nWenn du das Thema mitverfolgen möchtest, speichere dir bitte diesen Link:\n["
    + ((stack1 = alias1(depth0, depth0)) != null ? stack1 : "")
    + "|"
    + ((stack1 = alias1(depth0, depth0)) != null ? stack1 : "")
    + "]";
},"useData":true});